<div
  class="modal fade"
  id="comment_modal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
  <div class="modal-dialog modal-xl modal-dialog-centered custom-modal" :class="{ 'timeline-side-dialog': timeline_panel_visible }">
    <div class="modal-content modern-modal report-comment-modal border-0 rounded overflow-hidden" :class="{ 'timeline-side-panel-open': timeline_panel_visible }">
      <div class="report-comment-layout d-grid h-100">
        <div class="report-comment-main d-flex flex-column h-100">
      <!-- HEADER -->
      <div class="modal-header modern-header">
        <button class="btn-close" @click="hide_modal"></button>
      </div>
      <!-- BODY -->
      <div class="modal-body">
        <!-- POST CONTENT -->
        <div class="post-section">
          <div class="post-header d-flex align-items-center gap-2 mb-2">
            <!-- {{report_data}} -->
            <div class="avatar-sm">
              <img
                v-if="!dwypd_domain && !soulcity_domain && get_active_profile_picture(report_data)"
                :src="get_active_profile_picture(report_data)"
                loading="lazy"
                class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0"
                alt="Profile Picture"
              />
              <i v-else class="bi bi-person-circle fs-4 text-dark pointer"></i>
            </div>

            <div>
              <div class="fw-bold text-sm">
                <span
                  v-if="report_data?.base_profile?.profile_type === 'personal'"
                >
                  {{ report_data.base_profile?.user?.first_name }} {{
                  report_data.base_profile?.user?.last_name }}
                </span>
                <span v-else>
                  {{ report_data.base_profile?.company?.company_name }}
                </span>
              </div>
              <div class="text-muted text-xxs">
                {{ report_data.publication_date }}
              </div>
            </div>
          </div>

          <h6 class="fw-bold mb-2">{{ report_data.name }}</h6>

          <div v-html="report_data.description" class="text-muted mb-3"></div>
          <div>
            <!-- FILES (audio / video / downloads) -->
            <div
              class="d-flex flex-column"
              v-if="report_data.report_files && report_data.report_files.length"
            >
              <div
                v-for="(fileObj, index) in filtered_files(report_data.report_files)"
                :key="index"
                class="mb-3"
              >
                <!-- AUDIO -->
                <audio
                  v-if="fileObj?.file?.url &&
                    (fileObj.file.url.includes('.mp3') ||
                     fileObj.file.url.includes('.wav'))"
                  controls
                  class="w-100"
                >
                  <source :src="fileObj.file.url" type="audio/mp3" />
                </audio>

                <!-- VIDEO -->
                <div
                  v-else-if="fileObj?.file?.url &&
                    /\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.url)"
                  class="media-wrapper align-items-center justify-content-center mb-2"
                >
                  <video controls>
                    <source :src="fileObj.file.url" />
                  </video>
                </div>

                <!-- OTHER FILES -->
                <div
                  v-else
                  class="uploaded-file d-flex align-items-center justify-content-between p-3 mb-2 rounded shadow-sm"
                  @click="open_preview(fileObj)"
                >
                  <!-- File Info -->
                  <div
                    class="d-flex align-items-center flex-grow-1 overflow-hidden"
                  >
                    <div
                      class="d-flex align-items-center justify-center me-3 flex-shrink-0"
                    >
                      <img
                        v-if="fileObj?.file?.url"
                        :src="getFileIcon(fileObj.file.url)"
                        class="file-icon small-icon"
                      />
                    </div>

                    <span class="file-name">
                      {{ getFileName(fileObj?.file?.url) }}
                    </span>
                  </div>
                  <!-- Actions -->
                  <div
                    class="d-flex align-items-center gap-3 flex-shrink-0 ms-3"
                  >
                    <a
                      :href="fileObj?.file?.url"
                      download
                      :title="getFileName(fileObj?.file?.url)"
                      class="file-action-btn"
                      @click.stop
                    >
                      <i class="bi bi-download"></i>
                    </a>
                  </div>
                </div>
              </div>

              <!-- IMAGE GALLERY -->
              <div v-if="get_report_images(report_data).length">
                <div
                  class="report-modal-image-grid"
                  :class="{ 'single-image': get_report_images(report_data).length === 1 }"
                >
                  <button
                    v-for="(src, i) in get_report_images(report_data)"
                    :key="'report-modal-img-' + i"
                    type="button"
                    class="report-modal-image-frame bg-light border rounded-3 overflow-hidden p-0 w-100" >
                    <img :src="src" alt="Report image" />
                  </button>
                </div>
              </div>
            </div>

            <!-- LINK PREVIEW -->
            <div
              v-if="report_data.linkPreview"
              class="link-preview rounded mt-3 p-2 border position-relative"
            >
              <a
                :href="report_data.report_link"
                target="_blank"
                class="stretched-link text-decoration-none"
              >
                <img
                  v-if="report_data.linkPreview.image"
                  :src="report_data.linkPreview.image"
                  class="img-fluid rounded mb-2"
                />

                <div class="fw-bold">{{ report_data.linkPreview.title }}</div>

                <div
                  v-if="!report_data.linkPreview.image"
                  class="text-muted small"
                >
                  {{ report_data.linkPreview.description }}
                </div>
              </a>
            </div>
          </div>
        </div>

        <div class="report-modal-tabs d-grid border-bottom mb-3" role="tablist" aria-label="Report sections">
          <button
            type="button"
            class="report-modal-tab d-inline-flex align-items-center justify-content-center gap-2 p-2 bg-transparent border-0"
            :class="{ active: active_comment_tab === 'timeline' }"
            @click="set_comment_tab('timeline')"
          >
            <i class="bi bi-activity"></i>
            <span>Timeline</span>
          </button>
          <button
            type="button"
            class="report-modal-tab d-inline-flex align-items-center justify-content-center gap-2 p-2 bg-transparent border-0"
            :class="{ active: active_comment_tab === 'comments' }"
            @click="set_comment_tab('comments')"
          >
            <i class="bi bi-chat"></i>
            <span>Comments ({{ report_data.total_comments || comments_data.length || 0 }})</span>
          </button>
        </div>
        <div v-if="active_comment_tab === 'timeline'" class="timeline-panel pb-2">
          <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
            <div>
              <div class="fw-bold text-sm">Journey Timeline</div>
              <div class="text-muted text-xxs">Milestones and updates from this journey.</div>
            </div>
            <button
              v-if="can_manage_report_timeline()"
              type="button"
              class="btn btn-sm btn-primary d-inline-flex align-items-center gap-1 text-nowrap text-xxs rounded"
              @click="open_add_timeline_modal"
            >
            
              <span>Add Timeline Update</span>
            </button>
          </div>

          <div v-if="!timeline_updates.length" class="timeline-empty d-flex align-items-center gap-2 p-3 rounded bg-light text-muted">
            <i class="bi bi-calendar2-plus"></i>
            <div>
              <div class="fw-semibold text-xs">No timeline updates yet</div>
              <div class="text-muted text-xxs">Add the first milestone so viewers can follow the progress.</div>
            </div>
          </div>

          <div v-else class="journey-timeline-list">
            <div
              v-for="update in sorted_timeline_updates()"
              :key="update.id"
              class="journey-timeline-item"
            >
              <div class="journey-timeline-marker"></div>
              <div class="journey-timeline-card bg-white border rounded p-3">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div class="min-w-0">
                    <div class="timeline-month text-primary fw-bold">{{ get_timeline_month(update) }}</div>
                    <div class="fw-bold text-xs ">{{ update.title }}</div>
                    <div class="text-muted text-xxs timeline-description">{{ update.description }}</div>
                  </div>
                </div>

                <div v-if="update.images && update.images.length" class="timeline-image-row d-flex flex-wrap gap-2 mt-2">
                  <div
                    v-for="(media, index) in update.images.slice(0, 4)"
                    :key="get_timeline_media_preview(media) + index"
                    class="timeline-thumb rounded overflow-hidden position-relative"
                  >
                    <video
                      v-if="is_timeline_video(media)"
                      :src="get_timeline_media_preview(media)"
                      muted
                      playsinline
                      preload="metadata"
                    ></video>
                    <img v-else-if="is_timeline_image(media)" :src="get_timeline_media_preview(media)" alt="Timeline media" />
                    <button
                      v-else
                      type="button"
                      class="w-100 h-100 border-0 bg-light d-flex flex-column align-items-center justify-content-center p-2 text-muted"
                      @click="open_preview({ file: { url: media.preview, name: media.name } })"
                    >
                      <i class="bi bi-file-earmark-text fs-5"></i>
                      <span class="text-xxs text-truncate w-100">{{ media.name }}</span>
                    </button>
                    <i v-if="is_timeline_video(media)" class="bi bi-play-fill timeline-video-badge position-absolute top-50 start-50 translate-middle d-inline-flex align-items-center justify-content-center rounded-circle text-white"></i>
                    <span v-if="index === 3 && update.images.length > 4" class="timeline-thumb-count position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center text-white">
                      +{{ update.images.length - 4 }}
                    </span>
                  </div>
                </div>

                <div class="timeline-meta d-flex align-items-center gap-3 mt-2 text-primary fw-bold">
                  <span><i class="bi bi-images"></i> {{ get_timeline_media_count(update) }} media</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- COMMENTS -->
        <div v-if="active_comment_tab === 'comments'">
          <div class="fw-bold mb-3">
            Comments ({{ report_data.total_comments || comments_data.length || 0 }})
          </div>

          <div
            v-for="comment in comments_data"
            :key="comment.id"
            class="d-flex mb-3"
          >
            <div class="comment-avatar-wrapper me-2">
              <img
                v-if="!dwypd_domain && !soulcity_domain && get_active_profile_picture(comment)"
                :src="get_active_profile_picture(comment)"
                loading="lazy"
                class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0"
                alt="Profile Picture"
              />
              <i v-else class="bi bi-person-circle fs-4 text-dark pointer"></i>
            </div>

            <div class="comment-content flex-grow-1">
              <div class="text-xxs text-muted mt-1">{{ comment.time }}</div>
              <div class="">
                <div class="fw-semibold text-xs">
                  {{ comment.base_profile?.user?.first_name }}
                </div>
                <div class="text-xs">{{ comment.comment_text }}</div>
              </div>

              <div v-if="token_exists" class="d-flex align-items-center gap-3 mt-2">
                <span class="fw-bold text-xxs pointer" @click="toggler_comment_input(comment.id)">
                  Reply <i class="bi bi-reply"></i>
                </span>
                <span
                  v-if="(comment.reply_comment || []).filter(Boolean).length"
                  class="text-primary text-xxs fw-bold pointer"
                  @click="toggleReplies(comment.id)"
                >
                  {{ are_replies_visible(comment.id) ? 'See less' : 'View (' + (comment.reply_comment || []).filter(Boolean).length + ') replies' }}
                </span>
              </div>

              <div v-if="is_reply_input_visible(comment.id)" class="d-flex align-items-center border rounded mt-2 px-2">
                <i class="bi bi-person-circle fs-5 text-dark me-2"></i>
                <input
                  class="form-control form-control-sm border-0 bg-transparent text-xxs"
                  :value="get_reply_text(comment.id)"
                  @input="set_reply_text(comment.id, $event.target.value)"
                  type="text"
                  placeholder="Write a reply..."
                  @keyup.enter.prevent="submit_reply(comment.id)"
                />
                <button class="btn btn-sm text-xxs" type="button" @click="submit_reply(comment.id)">
                  <i class="bi bi-send-fill text-black fs-6"></i>
                </button>
              </div>

              <div v-if="are_replies_visible(comment.id)" class="mt-3 ps-2">
                <div
                  v-for="(reply, index) in (comment.reply_comment || []).filter(Boolean)"
                  :key="reply.id || index"
                  class="d-flex align-items-start mb-2 w-100"
                >
                  <div class="comment-avatar-wrapper me-2">
                    <img
                      v-if="get_active_profile_picture(reply)"
                      :src="get_active_profile_picture(reply)"
                      class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0"
                      alt="Profile Picture"
                    />
                    <i v-else class="bi bi-person-circle fs-5 text-dark pointer"></i>
                  </div>
                  <div class="flex-grow-1">
                    <div class="text-xs">
                      <strong>
                        <span v-if="reply.base_profile?.profile_type === 'business'">
                          {{ reply.base_profile?.company?.company_name }}
                        </span>
                        <span v-else>
                          {{ reply.base_profile?.user?.first_name || reply.base_profile?.creater?.first_name || reply.user?.first_name }}
                          {{ reply.base_profile?.user?.last_name || reply.base_profile?.creater?.last_name || reply.user?.last_name }}
                        </span>
                      </strong>
                      <span class="text-muted ms-1 text-xxs">&middot; {{ reply.time }}</span>
                    </div>
                    <div class="text-xs">{{ reply.reply }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div v-if="token_exists && active_comment_tab === 'comments'" class="modal-footer modern-footer">
        <div class="input-group">
          <input
            v-model="commentText"
            class="form-control comment-input"
            placeholder="Write a comment..."
            @keyup.enter.prevent="submit_comment"
          />

          <button class="btn btn-primary px-3" type="button" @click="submit_comment">
            <i class="bi bi-send"></i>
          </button>
        </div>
      </div>
        </div>

        <aside v-if="timeline_panel_visible" class="timeline-side-panel bg-white border-start d-flex flex-column h-100">
          <div class="timeline-side-header d-flex align-items-center justify-content-between flex-shrink-0 px-4 pt-4 pb-3">
            <h5 class="fw-bold mb-0">
              {{ editing_timeline_update_id ? 'Edit Timeline Update' : 'Add Timeline Update' }}
            </h5>
            <button type="button" class="btn-close" @click="close_timeline_modal"></button>
          </div>

          <form class="timeline-form timeline-side-form" @submit.prevent="save_timeline_update">
            <div class="mb-3">
              <label class="form-label text-xs fw-semibold">Timeline Title <span class="text-danger">*</span></label>
              <input
                v-model="timeline_form.title"
                maxlength="100"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': timeline_errors.title }"
                placeholder="e.g. Campaign testing started"
              />
              <div class="d-flex justify-content-between mt-1">
                <div class="invalid-feedback d-block text-xxs">{{ timeline_errors.title }}</div>
                <span class="text-muted text-xxs">{{ timeline_form.title.length }}/100</span>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label text-xs fw-semibold">Timeline Date <span class="text-danger">*</span></label>
              <input
                v-model="timeline_form.date"
                type="date"
                class="form-control"
                :class="{ 'is-invalid': timeline_errors.date }"
              />
              <div class="invalid-feedback d-block text-xxs">{{ timeline_errors.date }}</div>
            </div>

            <div class="mb-3">
              <label class="form-label text-xs fw-semibold">Description <span class="text-danger">*</span></label>
              <textarea
                v-model="timeline_form.description"
                maxlength="500"
                class="form-control timeline-description-input"
                :class="{ 'is-invalid': timeline_errors.description }"
                placeholder="Share what happened in this update..."
              ></textarea>
              <div class="d-flex justify-content-between mt-1">
                <div class="invalid-feedback d-block text-xxs">{{ timeline_errors.description }}</div>
                <span class="text-muted text-xxs">{{ timeline_form.description.length }}/500</span>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label text-xs fw-semibold">Files <span class="fw-normal text-muted">(You can add multiple files)</span></label>
              <div class="timeline-upload-strip d-flex flex-wrap gap-2 mt-2">
                <div
                  v-for="(media, index) in timeline_form.images"
                  :key="media.preview + index"
                  class="timeline-upload-thumb rounded overflow-hidden position-relative"
                >
                  <video
                    v-if="is_timeline_video(media)"
                    :src="media.preview"
                    muted
                    playsinline
                    preload="metadata"
                  ></video>
                  <img v-else-if="is_timeline_image(media)" :src="media.preview" alt="Timeline upload" />
                  <div v-else class="w-100 h-100 bg-light d-flex flex-column align-items-center justify-content-center p-2 text-muted">
                    <i class="bi bi-file-earmark-text fs-5"></i>
                    <span class="text-xxs text-truncate w-100 text-center">{{ media.name }}</span>
                  </div>
                  <i v-if="is_timeline_video(media)" class="bi bi-play-fill timeline-video-badge position-absolute top-50 start-50 translate-middle d-inline-flex align-items-center justify-content-center rounded-circle text-white"></i>
                  <button type="button" class="timeline-remove-image position-absolute top-0 end-0 m-1 d-inline-flex align-items-center justify-content-center rounded-circle border-0 text-white" @click="remove_timeline_image(index)">
                    <i class="bi bi-x"></i>
                  </button>
                </div>

                <label class="timeline-upload-button d-inline-flex align-items-center justify-content-center rounded overflow-hidden position-relative">
                  <i class="bi bi-plus-lg"></i>
                  <input type="file" class="d-none" multiple @change="handle_timeline_images" />
                </label>
              </div>
              <div class="text-muted text-xxs mt-2">Drag and drop images or videos here, or click to upload.</div>
            </div>

            <div class="timeline-form-note d-flex align-items-center gap-2 p-3 rounded bg-primary-subtle border border-primary-subtle mb-4">
              <i class="bi bi-lightbulb"></i>
              <span>This update will be added to your timeline and visible in the Journey Timeline section.</span>
            </div>

            <div class="modal-footer">
              <button type="submit" class="btn btn-primary text-xxs rounded">
                {{ editing_timeline_update_id ? 'Save' : 'Save' }}
              </button>
            </div>
          </form>
        </aside>
      </div>
    </div>
  </div>
</div>

<teleport to="body">
  <div class="modal fade" id="report_preview_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Preview</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body text-center position-relative">
          <div v-if="loading_preview" class="temporary-post posting-loader-card">
            <div class="posting-loader-icon" aria-hidden="true">
              <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            </div>
            <div class="posting-loader-content">
              <p class="mb-2 fw-bold text-xs text-truncate">{{ preview_file_name || 'Feed' }} - Posting...</p>
              <div class="posting-loader-track" aria-hidden="true">
                <span></span>
              </div>
            </div>
          </div>

          <div v-if="preview_type === 'pdf'" class="ratio ratio-16x9">
            <iframe :src="preview_url" width="100%" height="100%" frameborder="0" @load="on_content_loaded"></iframe>
          </div>

          <div v-else-if="preview_type === 'image'">
            <img :src="preview_url" class="img-fluid rounded report-preview-image" @load="on_content_loaded" />
          </div>

          <div v-else-if="preview_type === 'video'">
            <video controls class="img-fluid rounded" @loadedmetadata="on_content_loaded">
              <source :src="preview_url" :type="'video/' + preview_url.split('.').pop()" />
              Your browser does not support the video tag.
            </video>
          </div>

          <div v-else-if="preview_type === 'audio'">
            <audio controls class="w-100 my-3" @loadedmetadata="on_content_loaded">
              <source :src="preview_url" :type="'audio/' + preview_url.split('.').pop()" />
              Your browser does not support the audio element.
            </audio>
          </div>

          <div v-else-if="preview_type === 'office'" class="ratio ratio-16x9">
            <iframe
              :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(preview_url)"
              width="100%"
              height="100%"
              frameborder="0"
              @load="on_content_loaded"
            ></iframe>
          </div>

          <div v-else-if="preview_type === 'text'">
            <iframe :src="preview_url" width="100%" height="500px" frameborder="0" @load="on_content_loaded"></iframe>
          </div>

          <div v-else>
            <p>
              Preview not available. You can
              <a :href="preview_url" target="_blank" download>download the file</a>
              to view it.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<div class="d-none flex-grow-1 border-custom my-2 ms-3" id="reply_template">
  <div class="d-flex flex-start">
    <i class="bx bxs-user-circle text-secondary fs-2"></i>
    <div>
      <div class="d-flex justify-content-between align-items-center">
        <p class="mb-1 text-xxs">
          <span class="me-1 fw-bold reply_Name"></span>
          <span class="me-1 fw-bold reply_last_name"></span>
          <span class="small text-xxs fs-500 reply_time"></span>
        </p>
        <div class="dropstart reply_dropdown" v-if="token_exists">
          <a href="#" class="text-dark" data-bs-toggle="dropdown">
            <i class="bi bi-three-dots-vertical"></i>
          </a>
          <ul class="dropdown-menu w-100 shadow rounded-5 border-0">
            <li>
              <a class="dropdown-item text-info edit_reply"
                ><i class="bi bi-pencil text-xxs fw-500"></i> Edit</a
              >
            </li>
            <li>
              <a
                class="dropdown-item text-danger delete_reply"
                v-if="user_details.user_role=='admin'&& token_exists"
                ><i class="bi bi-trash text-xxs fw-500"></i> Delete</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="reply_text_container">
        <p class="small mb-2 text-xxs comment_text"></p>
        <div class="input-group mb-3 edit_reply_input d-none">
          <input
            type="text"
            class="form-control text-xxs rounded-start edit_reply_text"
            placeholder="Edit your reply"
          />
          <span class="input-group-text rounded-end save_edit_reply">
            <i class="bi bi-send"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="read-more-section text-xs d-none" id="read_more_template">
  <span class="text-primary cursor-pointer read-more-button">Read more</span>
  <span class="text-primary cursor-pointer read-less-button d-none"
    >Read less</span
  >
</div>
